Bacon = require 'baconjs'
R = require 'ramda'

simulateErrors = false

{ bugsnagClient } = require 'utils/bugsnag'

toJSON = (response) ->
  response.json()

responseToJSON = (response) ->
  Bacon
    .fromPromise response.json()
    .mapError R.always {}

checkResponseStatus = (data) ->
  if !data.success
    new Bacon.Error(R.prop('message', data) || R.path(['error', 'message'], data) || data)
  else
    new Bacon.Next(data)


fixProtocol = (url) ->
  url.replace /^http:/, window.location.protocol

removeSchema = fixProtocol

jsonHeaders =  {
  'Accept': 'application/json',
  'Content-Type': 'application/json; charset=utf-8'
}

loadJSON = (url) ->
  Bacon
    .fromPromise fetch removeSchema url
    .flatMap responseToJSON

log = R.curry (start, label, params, value) ->
  if __DEV__
    duration = new Date - start
  value

withRetry = (method, url, source) ->
  if !url
    console.error "Cannot #{method} #{url}"
    return
  Bacon
    .retry
      source: source
      retries: 5
      isRetryable: (error) ->
        statusCode = R.path ['status', 'code'], error
        if (statusCode and statusCode isnt 401) or (!!error.httpStatusCode and error.httpStatusCode isnt 401)
          errorPayload =
            resource: {method, url}
            error:
              code: error.httpStatusCode
              status:  statusCode
              raw: error

          bugsnagClient.notify new Error("Network Issue (retrying)"), { metaData: { errorPayload } }

          if !!window and window.console and window.console.error
            console.error "Network Issue (retrying)", errorPayload
          true
        else
          false
      delay: ({error, retriesDone}) ->
        retriesDone * 100

loadResourceFromParamsURLWithCache = (params) ->
  GET(params).flatMap( checkResponseStatus )

loadResourceFromURLWithCache = (url, params = {}) ->
  GET(url, params).flatMap( checkResponseStatus )

createResource = (params) ->
  POST(params).flatMap( checkResponseStatus )

updateResource = (params) ->
  PUT(params).flatMap( checkResponseStatus )

deleteResource = (params) ->
  DEL(params).flatMap ( checkResponseStatus )

findResourceLink = R.curry (resourceName, method, data) ->
  link = R.find (resource) ->
    methods = R.defaultTo R.of(resource.method), resource.methods
    resource.name is resourceName and R.contains method, methods
  , data.links
  if link
    console.warn("findResourceLink for #{resourceName}, #{method}, #{data} is null") if __DEV__ and !link.url
    link.url

renameProp = R.curry (oldName, newName, obj) ->
  value = R.prop(oldName, obj)
  R.assoc newName, value, R.dissoc oldName, obj

nclog = R.curry (label, val) ->
  val

processJSONWithStatus = (response) ->
  if response.status >= 200 and response.status < 300
    responseToJSON(response)
      .flatMap (data) ->
        new Bacon.Next data
  else
    responseToJSON(response)
      .flatMap (data) ->
        new Bacon.Error data

GET = (urlOrParams) ->
  addParam = (sum, [key, val]) ->
    param = "#{key}=#{encodeURIComponent val}"
    sum + if sum.length > 1 then "&" + param else param


  if R.is String, urlOrParams
    url = urlOrParams
  else
    params = R.dissoc 'url', urlOrParams
    url = urlOrParams.url + R.reduce addParam, "?", R.toPairs params

  withRetry "GET", url, ->
    Bacon.fromPromise fetch(removeSchema(url), method: 'GET', headers: jsonHeaders)
  .flatMap processJSONWithStatus
  .map log new Date, "GET #{url}", {}

PUT = (params) ->
  withRetry "PUT", params.url, ->
    Bacon.fromPromise(fetch(removeSchema( params.url ), method: 'PUT', headers: jsonHeaders,  body: JSON.stringify(R.dissoc('url', params))))
  .flatMap processJSONWithStatus
  .map log new Date, "PUT #{params.url}", params

POST = (params) ->
  withRetry "POST", params.url, ->
    Bacon
      .fromPromise(fetch(removeSchema(params.url), method: 'POST', headers: jsonHeaders, body: JSON.stringify(R.dissoc('url', params))))
  .flatMap processJSONWithStatus
  .map log new Date, "POST #{params.url}", params

DEL = (params) ->
  withRetry "DELETE", params.url, ->
    Bacon
      .fromPromise(fetch(removeSchema( params.url ), method: 'DELETE', headers: jsonHeaders, body: JSON.stringify(R.dissoc('url', params))))
  .flatMap processJSONWithStatus
  .map log new Date, "DELETE #{params.url}", params

integrationUrl = (appUrl = "") ->
  url = R.path ['location', 'href'], window || {}
  if url
    url = url
      .replace(/autologin-provider.*?($|&)/, '')
      .replace(/autologin-secret-key.*?($|&)/, '')
    R.nth(0, url.split(/#/)) + appUrl

module.exports =
  get: GET
  put: PUT
  post: POST
  delete: DEL
  loadJSON: loadJSON
  loadResourceFromURL: loadResourceFromURLWithCache
  loadResourceFromURLWithParams: loadResourceFromParamsURLWithCache
  # loadResourceFromURL: loadResourceFromURL
  createResource: createResource
  updateResource: updateResource
  deleteResource: deleteResource
  findResourceLink: findResourceLink
  renameProp: renameProp
  nclog: nclog
  removeSchema: removeSchema
  integrationUrl: integrationUrl
  setClientInfo: (app, channel) ->
    jsonHeaders = R.merge jsonHeaders,
      'Z-Client-App': app
      'Z-Client-Channel': channel
